import { render, staticRenderFns } from "./TopicScatter.vue?vue&type=template&id=0668f7d8&scoped=true&"
import script from "./TopicScatter.vue?vue&type=script&lang=js&"
export * from "./TopicScatter.vue?vue&type=script&lang=js&"
import style0 from "./TopicScatter.vue?vue&type=style&index=0&id=0668f7d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0668f7d8",
  null
  
)

export default component.exports